import { composeFetch } from '@library/http'
import {
  addPath,
  composeRequest,
  goustoHeaders,
  setMethod,
  setQueryParams,
  setServiceUrl,
} from '@library/http/requests'

import type { BasketInput, BasketResponse } from './interfaces/basket'

const getBasketResponseParser = async (response: Response): Promise<BasketResponse> => {
  if (!response.ok) {
    const responseMsg = await response.text()
    throw new Error(`service responded with ${response.status}: ${responseMsg}`)
  }

  return response.json()
}

export const basketFetcher = composeFetch(
  composeRequest<BasketInput>(
    setServiceUrl('menuexperience', 1),
    addPath('basket'),
    goustoHeaders,
    setMethod('GET'),
    setQueryParams(({ menuId, numPortions, deliveryDate, postcode, products, recipes }) => ({
      menuId,
      numPortions: numPortions.toString(),
      deliveryDate,
      postcode,
      recipes: JSON.stringify(recipes),
      ...(products ? { products: JSON.stringify(products) } : {}),
    })),
  ),
  getBasketResponseParser,
)
